import { Column, Entity, Index } from 'typeorm';
import { BaseEntity } from './base.entity';

/**
 * OAuth state for CSRF protection during authorization flow.
 * These records are short-lived (10 minutes) and cleaned up after use.
 */
@Entity('recon_oauth_states')
@Index('idx_recon_oauth_state', ['state'])
@Index('idx_recon_oauth_expires', ['expiresAt'])
export class ReconOAuthStateEntity extends BaseEntity {
	/**
	 * Random state parameter for CSRF protection.
	 * Must match the state returned in the callback.
	 */
	@Column('varchar', { name: 'state', length: 128, unique: true })
	public state!: string;

	/**
	 * Platform identifier.
	 * 'twitter', 'reddit', 'linkedin', 'youtube', 'discord'
	 */
	@Column('varchar', { name: 'platform', length: 50 })
	public platform!: string;

	/**
	 * PKCE code verifier (for platforms that require it).
	 * Used to verify the authorization code exchange.
	 */
	@Column('varchar', { name: 'code_verifier', length: 128, nullable: true })
	public codeVerifier!: string | null;

	/**
	 * When this state expires.
	 * States should be valid for 10 minutes max.
	 */
	@Column('datetime', { name: 'expires_at' })
	public expiresAt!: Date;

	/**
	 * Optional redirect URL to return to after OAuth completes.
	 */
	@Column('text', { name: 'redirect_url', nullable: true })
	public redirectUrl!: string | null;
}
